var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11102",
    "data-name": "Group 11102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.508,
    height: 93.229,
    viewBox: "0 0 78.508 93.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1154",
    "data-name": "Rectangle 1154",
    width: 78.508,
    height: 93.229,
    fill: "#77ffa5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3361",
    "data-name": "Group 3361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11048",
    "data-name": "Path 11048",
    d: "M57.088,28.281V20.2C57.088,9.05,47.252,0,35.131,0S13.174,9.05,13.174,20.2v8.08C5.9,28.281,0,33.711,0,40.4V68.682C0,75.372,5.9,80.8,13.174,80.8H57.088c7.272,0,13.174-5.43,13.174-12.12V40.4c0-6.69-5.9-12.12-13.174-12.12M21.957,20.2c0-6.69,5.9-12.12,13.174-12.12S48.306,13.51,48.306,20.2v8.08H21.957ZM61.48,68.682a4.228,4.228,0,0,1-4.391,4.04H13.174a4.228,4.228,0,0,1-4.391-4.04V40.4a4.228,4.228,0,0,1,4.391-4.04H57.088A4.228,4.228,0,0,1,61.48,40.4Z",
    transform: "translate(3.537 5.787)",
    fill: "#77ffa5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.8ea220cd2e610c7ffa9a2f868084405d.svg";
export { ForwardRef as ReactComponent };